import { legacyPlugins } from "/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/node_modules/.pnpm/@unhead+vue@3.3.1_@oxc-project+types@0.144.0_esbuild@0.25.3_lightningcss@1.33.0_oxc-par_453057b3b5adc16334a2cbdb2a6c5a2d/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}